import { Service } from '@/utils/dialogs';

const service = Service();

export default service;
